import comp from "./CriteriaRatingV2";
export default comp;
